import marketData from './market'
import { lotteryData } from './lottery'
import {
  getDefaultFinalSellData,
  sellCount,
  sellData,
  sellRecordList,
  specifiedSellData,
  targetPlayerId,
} from './sell'

export default {
  timezoneMap: {
    1: -5,
    2: -5,
    3: 8,
    5: 9,
  },
  playEndTime: 0,
  shareCoin: 0,
  shareValue: 0,
  isEnded: false,
  isReward: false,
  lotteryData,
  marketData,
  sellData,
  specifiedSellData,
  finalSellData: getDefaultFinalSellData(),
  sellCount,
  targetPlayerId,
  sellRecordList,
  sellModalOpen: window.queryObj.modal === 'sell' ? true : false,
  sellListModalOpen: window.queryObj.modal === 'sell-list' ? true : false,
  finalSellModalOpen: window.queryObj.modal === 'final-sell' ? true : false,
  shareDialogModalOpen: window.queryObj.modal === 'share-dialog' ? true : false,
  bookDialogModalOpen: window.queryObj.modal === 'book-dialog' ? true : false,
  receiveModalOpen: false,
  rewardViewList: [] as RewardViewList,
  rewardHideText: false,
}
